const actions = {
	
	CREATE_BEGIN: 'CREATE_BEGIN',
	CREATE_SUCCESS: 'CREATE_SUCCESS',
	CREATE_ERR: 'CREATE_ERR',

	FETCH_DETAIL_BEGIN: 'FETCH_DETAIL_BEGIN',
	FETCH_DETAIL_SUCCESS: 'FETCH_DETAIL_SUCCESS',
	FETCH_DETAIL_ERR: 'FETCH_DETAIL_ERR',

	FETCH_LIST_BEGIN: 'FETCH_LIST_BEGIN',
	FETCH_LIST_SUCCESS: 'FETCH_LIST_SUCCESS',
	FETCH_LIST_ERR: 'FETCH_LIST_ERR',

	FETCH_PROCESS_BEGIN: 'FETCH_PROCESS_BEGIN',
	FETCH_PROCESS_SUCCESS: 'FETCH_PROCESS_SUCCESS',
	FETCH_PROCESS_ERR: 'FETCH_PROCESS_ERR',

	UPDATE_BEGIN: 'UPDATE_BEGIN',
	UPDATE_SUCCESS: 'UPDATE_SUCCESS',
	UPDATE_ERR: 'UPDATE_ERR',

	RECEIVE_BEGIN: 'RECEIVE_BEGIN',
	RECEIVE_SUCCESS: 'RECEIVE_SUCCESS',
	RECEIVE_ERR: 'RECEIVE_ERR',

	CANCEL_BEGIN: 'CANCEL_BEGIN',
	CANCEL_SUCCESS: 'CANCEL_SUCCESS',
	CANCEL_ERR: 'CANCEL_ERR',

	createBegin: () => {
		return {
			type: actions.CREATE_BEGIN,
		};
	},

	createSuccess: (data) => {
		return {
			type: actions.CREATE_SUCCESS,
			data,
		};
	},

	createErr: (err) => {
		return {
			type: actions.CREATE_ERR,
			err,
		};
	},

	fetchDetailBegin: () => {
		return {
			type: actions.FETCH_DETAIL_BEGIN,
		};
	},

	fetchDetailSuccess: (data) => {
		return {
			type: actions.FETCH_DETAIL_SUCCESS,
			data,
		};
	},

	fetchDetailErr: (err) => {
		return {
			type: actions.FETCH_DETAIL_ERR,
			err,
		};
	},

	fetchListBegin: () => {
		return {
			type: actions.FETCH_LIST_BEGIN,
		};
	},

	fetchListSuccess: (data) => {
		return {
			type: actions.FETCH_LIST_SUCCESS,
			data,
		};
	},

	fetchListErr: (err) => {
		return {
			type: actions.FETCH_PROCESS_ERR,
			err,
		};
	},

	fetchProcessBegin: () => {
		return {
			type: actions.FETCH_PROCESS_BEGIN,
		};
	},

	fetchProcessSuccess: (data) => {
		return {
			type: actions.FETCH_PROCESS_SUCCESS,
			data,
		};
	},

	fetchProcessErr: (err) => {
		return {
			type: actions.FETCH_LIST_ERR,
			err,
		};
	},

	updateBegin: () => {
		return {
			type: actions.UPDATE_BEGIN,
		};
	},

	updateSuccess: (data) => {
		return {
			type: actions.UPDATE_SUCCESS,
			data,
		};
	},

	updateErr: (err) => {
		return {
			type: actions.UPDATE_ERR,
			err,
		};
	},

	receiveBegin: () => {
		return {
			type: actions.RECEIVE_BEGIN,
		};
	},

	receiveSuccess: (data) => {
		return {
			type: actions.RECEIVE_SUCCESS,
			data,
		};
	},

	receiveErr: (err) => {
		return {
			type: actions.RECEIVE_ERR,
			err,
		};
	},

	cancelBegin: () => {
		return {
			type: actions.CANCEL_BEGIN,
		};
	},

	cancelSuccess: (data) => {
		return {
			type: actions.CANCEL_SUCCESS,
			data,
		};
	},

	cancelErr: (err) => {
		return {
			type: actions.CANCEL_ERR,
			err,
		};
	},

};

export default actions;
